import React from 'react';

interface UserProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

/** Matches design mock icon set (chrome.jsx `user`) — head circle + shoulders arc, 1.75 stroke. */
const UserIcon: React.FC<UserProps> = ({ width = 24, height = 24, className, style }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.75}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    style={style}
    aria-hidden
  >
    <circle cx="12" cy="8" r="3.5" />
    <path d="M4 21a8 8 0 0 1 16 0" />
  </svg>
);

export default UserIcon;
